type FeeLike = {
  readonly name?: string | null;
  readonly totalCents?: number | null;
};

type CartLike = {
  readonly fees?: ReadonlyArray<FeeLike | null> | null;
  readonly totalCents?: number | null;
};

type ServerOrderSurchargesInput = {
  readonly enablePosOrderSurchargesAsFees: boolean;
  readonly fees?: ReadonlyArray<FeeLike | null> | null;
};

type CartTotalWithServerOrderSurchargesInput = {
  readonly cart?: CartLike | null;
  readonly enablePosOrderSurchargesAsFees: boolean;
};

type CartWithServerOrderSurchargesInput<Cart extends CartLike | null | undefined> = {
  readonly cart: Cart;
  readonly enablePosOrderSurchargesAsFees: boolean;
};

export const getServerOrderSurchargeFeesCents = (fees?: ReadonlyArray<FeeLike | null> | null) =>
  (fees ?? []).reduce((total, fee) => total + (fee?.totalCents ?? 0), 0);

export const getServerOrderSurchargesCents = ({
  enablePosOrderSurchargesAsFees,
  fees,
}: ServerOrderSurchargesInput) => {
  if (!enablePosOrderSurchargesAsFees) {
    return 0;
  }

  return getServerOrderSurchargeFeesCents(fees);
};

export const getCartTotalCentsWithServerOrderSurcharges = ({
  cart,
  enablePosOrderSurchargesAsFees,
}: CartTotalWithServerOrderSurchargesInput) => {
  return (
    (cart?.totalCents ?? 0) +
    getServerOrderSurchargesCents({
      enablePosOrderSurchargesAsFees,
      fees: cart?.fees,
    })
  );
};

export const getCartWithServerOrderSurcharges = <Cart extends CartLike | null | undefined>({
  cart,
  enablePosOrderSurchargesAsFees,
}: CartWithServerOrderSurchargesInput<Cart>): Cart => {
  if (!cart) {
    return cart;
  }

  return {
    ...cart,
    totalCents: getCartTotalCentsWithServerOrderSurcharges({
      cart,
      enablePosOrderSurchargesAsFees,
    }),
  } as Cart;
};
